import { FunctionComponent, useState, KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { InputField } from "@/components/InputField/InputField";
import { Icon } from "@/components/Icon/Icon";

interface CtaPoolSectionProps {
	value: string[];
	onChange: (value: string[]) => void;
}

export const CtaPoolSection: FunctionComponent<CtaPoolSectionProps> = ({ value, onChange }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`copywritingSettings.ctaPool.${key}`);

	const [inputValue, setInputValue] = useState("");

	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		if (e.key === "Enter") {
			e.preventDefault();
			const trimmed = inputValue.trim();

			if (trimmed && !value.includes(trimmed)) {
				onChange([...value, trimmed]);
				setInputValue("");
			}
		}
	};

	const handleRemove = (index: number) => {
		onChange(value.filter((_, i) => i !== index));
	};

	return (
		<div className="flex flex-col gap-4">
			<p className="text-sm text-text-meta">{ts("description")}</p>

			<InputField
				handleChange={(e) => setInputValue(e.target.value)}
				name="ctaInput"
				placeholder={ts("placeholder")}
				showError={false}
				value={inputValue}
				onKeyDown={handleKeyDown}
			/>

			{value.length > 0 && (
				<div className="flex flex-wrap gap-2">
					{value.map((item, index) => (
						<span
							key={index}
							className="flex items-center gap-1 px-3 py-1 rounded-full bg-gray-100 text-sm text-text"
						>
							{item}
							<button
								className="text-text-meta hover:text-text"
								type="button"
								onClick={() => handleRemove(index)}
							>
								<Icon className="w-3 h-3" icon={faXmark} />
							</button>
						</span>
					))}
				</div>
			)}
		</div>
	);
};
